import React from 'react'
import Avatar from 'react-avatar'

export const CustomAvatar = ({fullname, size,round,color,className}) =>{

    return (
        <Avatar color={color} name={fullname} size={size} round={round} className={className}/>
    )
}